import { createContext } from 'react';
import { DropdownOptionWithSubLabel } from '@round/ui-kit';
import { FCWithChildren } from '../../../../utils/utils.types';
import { getXeroApexInvoices } from '@round/api';
import { useSelectPaginatedOptions } from '../../../../hooks/useSelectPaginatedOptions';
import { Props } from 'react-select';

type BookingsTableOptionsContextValues = {
    invoiceProps: Pick<Props, 'onInputChange' | 'isLoading' | 'onMenuScrollToBottom'> & {
        options: ReadonlyArray<DropdownOptionWithSubLabel<number>>;
    };
};

export const BookingsTableOptionsContext = createContext<BookingsTableOptionsContextValues | null>(null);

export const BookingsTableOptionsProvider: FCWithChildren = ({ children }) => {
    const { props: invoiceProps } = useSelectPaginatedOptions<
        DropdownOptionWithSubLabel<number>,
        typeof getXeroApexInvoices
    >({
        fetchOptions: getXeroApexInvoices,
        mapToOption: (inv) => ({
            value: inv.id,
            label: inv.invoice_number,
            subLabel: inv.reference,
        }),
    });

    return (
        <BookingsTableOptionsContext.Provider
            value={{
                invoiceProps: {
                    options: invoiceProps.options,
                    onMenuScrollToBottom: invoiceProps.onMenuScrollToBottom,
                    isLoading: invoiceProps.isLoading,
                    onInputChange: invoiceProps.onInputChange,
                },
            }}
        >
            {children}
        </BookingsTableOptionsContext.Provider>
    );
};
